module.exports = __webpack_public_path__ + "static/media/warning.8b0f5c12.svg";